import { useQuery } from 'react-query';
import request from '../helpers/request';

export const reqPrintFormKey = ['request-print-form'];

export const getRequestPrintForm = async () => {
  const res = await request.get(
    '/Request/print_form/awailable',
    {},
    'Не удалось получить доступные печатные формы'
  );

  return res;
};

const useRequestPrintForm = (options = {}) =>
  useQuery(reqPrintFormKey, getRequestPrintForm, {
    staleTime: Infinity,
    ...options,
  });

export default useRequestPrintForm;
